export default {
  en: {
    'saga.jurisdictions.failure': 'Failed to fetch jurisdictions',
    'saga.jurisdiction.failure': 'Failed to fetch jurisdiction',
  },
};
